import {Component, inject} from '@angular/core';
import {BaseRequestService} from "../../../../shared/base/base-request.service";
import {State} from "../../../../shared/base/base-state";
import {ApiService} from "../../../../core/api/api.service";
import {TableActionEvent} from "../../../../shared/components/data-table/data-table.component";
import {ContextMenuAction} from "../../../../shared/components/context-menu/context-menu.component";
import {
  TableCustomComponent
} from "../../../../shared/components/data-table/table-custom-component/table-custom.component";
import {
  ContextMenuButtonComponent
} from "../../../../shared/components/context-menu-button/context-menu-button.component";
import {
  DisableAdminUserRequest,
  DisableAdminUserResponse,
  EnableAdminUserRequest,
  EnableAdminUserResponse,
  GetAdminUserListItem
} from "../../../../core/api/model";

@Component({
  selector: 'app-table-cell-user-actions',
  imports: [
    ContextMenuButtonComponent
  ],
  templateUrl: './table-cell-user-actions.component.html',
  styleUrl: './table-cell-user-actions.component.scss'
})
export class TableCellUserActionsComponent extends TableCustomComponent<GetAdminUserListItem> {

  requestService = inject(BaseRequestService);
  apiService = inject(ApiService);
  enableUserState = new State<EnableAdminUserResponse>();
  disableUserState = new State<DisableAdminUserResponse>();

  get userActions(): ContextMenuAction[] {
    let actions: ContextMenuAction[] = [];
    let enableOption: ContextMenuAction = {label: 'Enable', actionKey: 'enableUser'};
    let disableOption: ContextMenuAction = {label: 'Disable', actionKey: 'disableUser'};
    if (this.rowData.isActive) {
      actions.push(disableOption);
    } else {
      actions.push(enableOption);
    }
    return actions;
  }

  handleUserAction(actionType: string) {
    if (actionType === 'enableUser') {
      this.onEnableClicked(this.rowData);
    }
    if (actionType === 'disableUser') {
      this.onDisableClicked(this.rowData);
    }
  }

  onEnableClicked(user: GetAdminUserListItem) {
    let request: EnableAdminUserRequest = {
      userIds: [user.id],
      message: "Enabling user"
    }
    this.requestService.executeRequest<EnableAdminUserResponse>(
      {
        state: this.enableUserState,
        request: this.apiService.enableAdminUser(request),
        handleSuccess: true,
        showLoader: true,
        onSuccess: () => {
          let event: TableActionEvent = {
            actionKey: 'enableUser',
            item: this.rowData,
          }
          this.actionPerformed.emit(event);
        }
      }
    );
  }

  onDisableClicked(user: GetAdminUserListItem) {
    let request: DisableAdminUserRequest = {
      userIds: [user.id],
      message: "Disabling user"
    }
    this.requestService.executeRequest<DisableAdminUserResponse>(
      {
        state: this.disableUserState,
        request: this.apiService.disableAdminUser(request),
        handleSuccess: true,
        showLoader: true,
        onSuccess: () => {
          let event: TableActionEvent = {
            actionKey: 'disableUser',
            item: this.rowData,
          }
          this.actionPerformed.emit(event);
        }
      }
    );
  }

}
